import { enumify } from "../messageTypes";
import { CardType } from "../lib/CardGames";
import { StreetName } from "../lib/PokerGames";

export type GameInfo = {
  self?: {
    cards: CardType[];
    forceClaimAt: number;
  };
  claims: { [k: string]: number[] };
  board: CardType[];
  result?: GameResult;
};

export type GameResult = {
  players: {
    [k: string]: { cards: CardType[]; position: number; rank: number };
  };
  isGameWon: boolean;
  nextGameAt?: number;
};

export namespace CoopPokerServer {
  const _Types = ["GAME_INFO"] as const;
  export const TypeValue = enumify("CoopPokerServer", _Types);
  export type Type = typeof TypeValue;

  export type GameInfoMessage = {
    type: Type["GAME_INFO"];
    data: GameInfo;
  };

  export type Message = GameInfoMessage;
}

export namespace CoopPokerClient {
  const _Types = ["CLAIM"] as const;
  export const TypeValue = enumify("CoopPokerClient", _Types);
  export type Type = typeof TypeValue;

  export type ClaimMessage = {
    type: Type["CLAIM"];
    data: {
      claim: number;
    };
  };

  export type Message = ClaimMessage;
}
